export const IS_FIAT_ONRAMP_ENABLED = true
